import { Injectable } from '@angular/core';
import { del, get, patch, post, put } from 'aws-amplify/api';

@Injectable({
  providedIn: 'root'
})
export class AmplifyApiAdapterService {
  get = get;
  post = post;
  put = put;
  patch = patch;
  del = del;
}
